var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar11 = function SvgDefaultAvatar11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F68DFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM23.25 25c0 1-.538 1.99-2 1.99h-9.002c-1.492 0-1.998-1.002-1.998-1.99 0-3.012 3-5.01 6.499-5.01 3.499 0 6.501 2.01 6.501 5.01Z",
    fill: "#49225B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 25c1.447 0 2-1.023 2-2 0-3.01-3.038-5-6.709-5-1.016 0-2.16.285-2.747.694-.587.408-.495.86 0 1.104 2.533 1.247 3.464 3.105 3.464 4.218 0 .634.43.984.984.984h3.008ZM19.25 16.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
    fill: "#49225B"
  })));
};
export default SvgDefaultAvatar11;